const EMBED = 'https://algolia.com/embed/';
const POLICIES = 'https://algolia.com/policies/';

/* Global */

export const ABOUT = 'https://algolia.com/about/';
export const ALGOLIA_VS_ELASTICSEARCH = 'https://algolia.com/algolia-vs-elasticsearch/';
export const CAREERS = 'https://algolia.com/careers/';
export const COMPARE_ALGOLIA_VS_ELASTICSEARCH =
  'https://algolia.com/compare-algolia-vs-elasticsearch/';
export const CONTACT_US = 'https://algolia.com/contactus/';
export const COVID_19 = 'https://algolia.com/covid-19/';
export const DEMO_REQUEST = 'https://algolia.com/demorequest/';
export const DEVELOPERS = 'https://algolia.com/developers/';
export const DISTRIBUTED_SECURE = 'https://algolia.com/distributed-secure/';
export const ERROR = '404';
export const EVENTS = 'https://algolia.com/events/';
export const FOR_OPEN_SOURCE = 'https://algolia.com/for-open-source/';
export const HOME = 'https://algolia.com/';
export const PRESS = 'https://algolia.com/press/';
export const PRICING = 'https://algolia.com/pricing/';
export const PRODUCTS = 'https://algolia.com/products/';
export const REDEEM = 'https://algolia.com/redeem/';
export const SEARCH = 'https://algolia.com/search/';
export const SEARCH_INSPIRATION_LIBRARY = 'https://algolia.com/search-inspiration-library/test';
export const SEARCH_AND_DISCOVERY = `${PRODUCTS}search-and-discovery/`;
export const SOCIAL_IMPACT = 'https://algolia.com/social-impact/';
export const SOLUTIONS = 'https://algolia.com/search-solutions/';
export const STATE_OF_SEARCH = 'https://algolia.com/state-of-site-search-and-discovery/';
export const SUPPORT = 'https://algolia.com/support/';
export const WHY = 'https://algolia.com/why/';

/* Developers */

export const CODE_EXCHANGE = `${DEVELOPERS}code-exchange/`;
export const CONTENTFUL_SEARCH_ALGOLIA = `${DEVELOPERS}contentful-search-algolia`;
export const DEVELOPERS_GET_STARTED = `${DEVELOPERS}get-started/`;
export const FIREBASE_SEARCH_EXTENSION = `${DEVELOPERS}firebase-search-extension/`;
export const INTEGRATIONS = `${DEVELOPERS}#integrations`;

/* Integrations */

export const ZENDESK = `/integrations/zendesk/`;

/* Policies */

export const ACCEPTABLE_USE = `${POLICIES}acceptable-use/`;
export const COOKIES = `${POLICIES}cookies/`;
export const INFRASTRUCTURE_AND_SUBPROCESSORS = `${POLICIES}infrastructure-and-sub-processors/`;
export const LEGAL = `${POLICIES}legal/`;
export const POLICIES_OLD = `${POLICIES}old/`;
export const POLICIES_SUPPORT = `${POLICIES}support/`;
export const PRIVACY = `${POLICIES}privacy/`;
export const SLA = `${POLICIES}sla/`;
export const TERMS = `${POLICIES}terms/`;

/* Products */

export const AI_SEARCH = `${PRODUCTS}ai-search/`;
export const AI_STUDIO = `${PRODUCTS}ai-studio/`;
export const RECOMMENDATIONS = `${PRODUCTS}recommendations/`;

/* Search and Discovery */

export const AB_TESTING = `${SEARCH_AND_DISCOVERY}ab-testing/`;
export const ANALYTICS = `${SEARCH_AND_DISCOVERY}analytics/`;
export const ANSWERS_FOR_PUBLISHERS = `${SEARCH_AND_DISCOVERY}answers-for-publishers/`;
export const ANSWERS_FOR_SUPPORT = `${SEARCH_AND_DISCOVERY}answers-for-customer-support/`;
export const CRAWLER = `${SEARCH_AND_DISCOVERY}crawler/`;
export const ENTERPRISE = `${SEARCH_AND_DISCOVERY}enterprise/`;
export const INSTANTSEARCH = `${SEARCH_AND_DISCOVERY}ui-component-libraries/`;
export const PERSONALIZATION = `${SEARCH_AND_DISCOVERY}personalization/`;
export const PERSONALIZED_QUERY_SUGGESTIONS = `${SEARCH_AND_DISCOVERY}personalized-query-suggestions/`;
export const PRODUCTS_SEARCH = `${SEARCH_AND_DISCOVERY}search/`;
export const RULES = `${SEARCH_AND_DISCOVERY}search-relevance-rules/`;
export const VISUAL_EDITOR = `${SEARCH_AND_DISCOVERY}visual-merchandising-curation/`;
export const HOSTED_SEARCH_API = `${SEARCH_AND_DISCOVERY}hosted-search-api/`;
export const ANSWERS = `${SEARCH_AND_DISCOVERY}answers/`;
export const SITE_SEARCH = `${SEARCH_AND_DISCOVERY}site-search/`;
export const HEADLESS_COMMERCE = `${SEARCH_AND_DISCOVERY}headless-commerce/`;
export const MOBILE_SEARCH = `${SEARCH_AND_DISCOVERY}mobile-search/`;
export const VOICE_SEARCH = `${SEARCH_AND_DISCOVERY}voice-search/`;

/* AI-Search */

export const DYNAMIC_SEARCH_RE_RANKING = `${AI_SEARCH}dynamic-reranking/`;
export const DYNAMIC_SYNONYM_SUGGESTIONS = `${AI_SEARCH}dynamic-synonym-suggestions/`;

/* Solutions */

export const AZURE = `${SOLUTIONS}algolia-on-azure/`;
export const B2B_ECOMMERCE = `${SOLUTIONS}b2b-ecommerce/`;
export const ECOMMERCE = `${SOLUTIONS}ecommerce/`;
export const MAGENTO = `${SOLUTIONS}adobe-commerce-magento/`;
export const MARKETPLACE_SEARCH = `${SOLUTIONS}marketplaces/`;
export const MEDIA = `${SOLUTIONS}media/`;
export const NETLIFY = `${SOLUTIONS}netlify/`;
export const SAAS = `${SOLUTIONS}saas/`;
export const SALESFORCE_COMMERCECLOUD = `${SOLUTIONS}salesforce-commerce-cloud/`;
export const SECURITY_MEASURES = `${SOLUTIONS}security/measures/`;
export const SHOPIFY = `${SOLUTIONS}shopify/`;

/* Distributed secure */

export const INFRASTRUCTURE = `${DISTRIBUTED_SECURE}global-infrastructure/`;
export const SECURITY = `${DISTRIBUTED_SECURE}security-compliance/`;

/* Resources */

export const CUSTOMERS = `/resources/customers/`;

/* Embed */

export const ABOUT_YOU_EMBED = `${EMBED}about-you/`;
export const BUSINESS_INFORMATION_EMBED = `${EMBED}business-information/`;
export const CHECK_EMAIL_EMBED = `${EMBED}check-email/`;
export const SIGN_UP_EMBED = `${EMBED}sign-up/`;
